import _ from '@lodash';

export const determineEditableAccess = (config, fieldConfig, fieldPrefix) => {
	const fieldPath = !_.isUndefined(fieldPrefix) && fieldPrefix !== null ? fieldPrefix + fieldConfig.key : fieldConfig.key;
	if (!_.isUndefined(config.editableAccess)) {
		if (config.editableAccess === 'NoAccess') return true;
		if (config.editableAccess === 'Full') return false;
		if (config.editableAccess === 'Restricted') {
			if (_.isUndefined(config.editableFields) || config.editableFields === null) return true;
			if (fieldPath.includes('.')) {
				const splittedFieldPath = fieldPath.split('.').filter(item => Number.isNaN(Number(item)));
				return config.editableFields.indexOf(splittedFieldPath.join('.')) === -1;
			}
			return config.editableFields.indexOf(fieldPath) === -1;
		}
	}

	return fieldConfig.readOnly || false;
};

export const fixDependsOn = (dependsOn, fieldPrefix) => {
	const result = [];
	if (_.isUndefined(dependsOn)) return result;
	if (_.isString(dependsOn)) return fixDependOn(dependsOn, fieldPrefix);
	if (_.isArray(dependsOn)) {
		dependsOn.forEach(d => {
			result.push(fixDependOn(d, fieldPrefix));
		});
	}
	return result;
};

export const fixDependOn = (dependOn, fieldPrefix) => {
	if (dependOn.startsWith('^')) return dependOn.substring(1);
	if (fieldPrefix) {
		return `${fieldPrefix}${dependOn}`;
	}
	return dependOn;
};

export const anotherOne = () => {};
